module.exports = __webpack_public_path__ + "static/media/17Demo Photo-ink-min.43540aac.jpeg";